import { render, staticRenderFns } from "./TaskTypes.vue?vue&type=template&id=68f688be&scoped=true&"
import script from "./TaskTypes.vue?vue&type=script&lang=js&"
export * from "./TaskTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f688be",
  null
  
)

export default component.exports